import React from 'react'

import { AssetList } from '../assetlist/AssetList'
import { BuyOfferList } from '../assetlist/BuyOfferList'
import { MarketList } from '../assetlist/MarketList'
import { BulkList } from '../bulklist/BulkList'
import { AuctionList } from '../assetlist/AuctionList'
import { getEndpoint } from '../helpers/FormatLinks'
import { SalesList } from '../assetlist/SalesList'
import LoadingIndicator from '../loadingindicator'

export const SearchResults = (props) => {
    const search = props['search']

    const endPoint = getEndpoint(search)
    const loadMoreButton = props['loadMoreButton']
    const isLoading = props['isLoading']
    const limit = props['limit']
    const assets = props['assets']

    return (
        <div className={'w-full h-auto mb-4 mt-4'}>
            {search.includes('bulk') ? (
                <BulkList {...props} />
            ) : endPoint === 'buyoffers' ? (
                <BuyOfferList {...props} />
            ) : endPoint === 'listings' ? (
                <MarketList {...props} />
            ) : endPoint === 'sales' ? (
                <SalesList {...props} />
            ) : endPoint === 'auctions' ? (
                <AuctionList {...props} />
            ) : (
                <AssetList {...props} />
            )}
            <div className={'w-full flex justify-center'}>
                {isLoading ? <LoadingIndicator /> : null}
                {!isLoading &&
                assets &&
                assets.length > 0 &&
                assets.length % limit === 0 &&
                loadMoreButton
                    ? loadMoreButton
                    : ''}
            </div>
        </div>
    )
}
